var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilters = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-35.000000, -195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Universes",
    transform: "translate(33.000000, 139.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exclusion-Filters",
    transform: "translate(0.984816, 45.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Content-/-filter_list",
    transform: "translate(0.000000, 5.997397)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79059017,10.4230623 L8.10682624,10.4230623 L8.10682624,9.26494427 L5.79059017,9.26494427 L5.79059017,10.4230623 Z M1.73717705,3.4743541 L1.73717705,4.63247214 L12.1602394,4.63247214 L12.1602394,3.4743541 L1.73717705,3.4743541 Z M3.4743541,7.52776722 L10.4230623,7.52776722 L10.4230623,6.36964919 L3.4743541,6.36964919 L3.4743541,7.52776722 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilters, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filters.b1fabe91.svg";
export { ForwardRef as ReactComponent };